export default __webpack_public_path__ + "static/media/deezer.555907ba.svg";